// extracted by mini-css-extract-plugin
module.exports = {"SearchButton":"SearchButton_SearchButton__2sGmM"};